import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProjectListPanelDisplayMode } from 'enums/app'

type ProjectListPageStateType = {
  displayMode: string
}

const initialProjectListPageState: ProjectListPageStateType = {
  displayMode: ProjectListPanelDisplayMode.List.id,
}

export const projectListPageSlice = createSlice({
  name: 'projectListPage',
  initialState: initialProjectListPageState,
  reducers: {
    displayModeUpdated: (state, action: PayloadAction<string>) => {
      state.displayMode = action.payload
    },
  },
})

export const { displayModeUpdated } = projectListPageSlice.actions
